import { Intent, ProgressBar } from "@blueprintjs/core";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import Sticky from "react-sticky-el";
import { HRSubSectionId } from "../../messages/ObjectIds";
import "./SubSectionLinkComponent.css";

interface SubSectionLinkComponentProps extends RouteComponentProps {
    id: HRSubSectionId;
    url: string;
    isClicked: boolean;
    status: number;
    title: string;
    onClick: (id: HRSubSectionId) => void;

}

class SubSectionLinkComponent extends React.Component<SubSectionLinkComponentProps> {
    constructor(props: SubSectionLinkComponentProps) {
        super(props);
    }

    render() {
        return (
            <Sticky
                positionRecheckInterval={300}
                hideOnBoundaryHit={true}
                stickyClassName={"SubSectionLinkComponent__sticky"}
                boundaryElement={".SubSectionLinkComponent__stickyBoundary"}
                topOffset={window.innerWidth > 600 ? 0 : -50}
            >
                <div onClick={() => this.props.onClick(this.props.id)}>
                    <div
                        className={"SubSectionLinkComponent__LinkContainer " + (this.props.isClicked ? "SubSectionLinkComponent__LinkContainerClicked" : "")}
                    >
                        <div className={"SubSectionLinkComponent__LinkHeader"}>
                            <h4 className={"SubSectionLinkComponent__header " + (this.props.isClicked ? "SubSectionLinkComponent__headerClicked" : "")}>
                                {this.props.title}
                            </h4>
                            <ProgressBar
                                className={"bp3-no-stripes SubSectionLinkComponent__progBar " + (this.props.isClicked ? "bp3-progress-bar-clicked" : "")}
                                intent={Intent.SUCCESS}
                                value={this.props.status / 100}
                                stripes={false}
                                animate={false}
                            />
                            <div
                                className={"SubSectionLinkComponent__percentage " + (this.props.isClicked ? "SubSectionLinkComponent__headerClicked" : "")}
                            >
                                {this.props.status}% complete
                            </div>
                        </div>
                    </div>
                </div>
            </Sticky>
        );
    }
}

export default withRouter(SubSectionLinkComponent);



// WEBPACK FOOTER //
// ./src/components/widgets/SubSectionLinkComponent.tsx